import { useNavigate } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  const navigate = useNavigate();

  return (
    <div className="not-found-container" data-testid="not-found-page">
      <div className="not-found-content">
        <h1 className="not-found-title">404</h1>
        <h2 className="not-found-subtitle">Page Not Found</h2>
        <p className="not-found-text">
          The page you're looking for doesn't exist or has been moved.
        </p>
        <div className="not-found-buttons">
          <button onClick={() => navigate('/')} className="not-found-btn primary" data-testid="home-button">
            Go Home
          </button>
          <button onClick={() => navigate('/wise-check')} className="not-found-btn secondary" data-testid="wise-check-button">
            Try Wise Check
          </button>
        </div>
      </div>
    </div>
  );
};

export default NotFound;